import { render, staticRenderFns } from "./RrcvD_Total.vue?vue&type=template&id=0a7677f1"
import script from "./RrcvD_Total.vue?vue&type=script&lang=js"
export * from "./RrcvD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports